import { flow } from 'lodash';
import { Sphere } from './Sphere';
import { withState } from './Sphere.withState';

export const SphereContainer = flow(
    //
    () => Sphere,
    withState()
)();
